import { render } from "./TrailCard.vue?vue&type=template&id=0f651034&scoped=true"
import script from "./TrailCard.vue?vue&type=script&lang=js"
export * from "./TrailCard.vue?vue&type=script&lang=js"

import "./TrailCard.vue?vue&type=style&index=0&id=0f651034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f651034"]])

export default __exports__